import React, { useEffect, useState } from 'react';
import { degrees, PDFDocument, rgb, StandardFonts, download } from "pdf-lib";
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import { Button, IconButton } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import Alert from '@material-ui/lab/Alert';
import RemoveIcon from '@material-ui/icons/Remove';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Loader from "react-loader-spinner";
import { Row, Col, Input, FormGroup, Collapse, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import {
    postData, putCourtUsed, putIncome, putChildren, putHardships, putLowIncome, putChildSupport,
    putMandatoryChildSupport, putAdditionalChildSupport, putNonGuidelineOrder, putHealthCareExpenses, putEmploymentSearchOrder, putOtherOrders, getChildSupport, deleteChildCall
} from "./childSupportInformation.actions";
import { connect } from 'react-redux';
import { isEmpty, isNumber, remove, filter, isUndefined, forEach, size, find, get } from "lodash";
import { serverApi, parseDate } from "../../../../../global/globalFunctions";
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));



const ChildSupportInformation = (props) => {

    const petitionerDetails = props.petitioner;
    const respondentDetails = props.respondent;
    const courtDetails = props.court;


    function getSteps() {
        return [
            'Printout of a Computer Calculation',
            'Income',
            'Children of this Relationship',
            'Hardships',
            'Low-Income Adjustment',
            'Child Support',
            'Mandatory Additional Child Support',
            'Additional Child Support',
            'Non-Guideline Order',
            'Health-Care Expenses ',
            'Employment Search Order',
            'Other Orders',
        ];
    }




    async function printFL192() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-192`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());

        var bytes = new Uint8Array(existingPdfBytes);
        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();

        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");
    }

    async function myFunction() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-342`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());
        var bytes = new Uint8Array(existingPdfBytes);
        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();

        let valueAmount = 0;

        !isEmpty(props.child_support.childDetail) && props.child_support.childDetail.map((amount) => {
            valueAmount = Number(valueAmount) + Number(amount.monthly_amount);
        })

        form.getField("Total_child_support_per_month").setText(valueAmount.toString());
        // Embed the font
        const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
        // Get all fields
        const p1 = form.getField("petitioner_name");
        const p2 = form.getField("PETITIONER");
        const p3 = form.getField("petitioner");
 
        const r1 = form.getField("respondent_name");
        const r2 = form.getField("RESPONDENT");
        const r3 = form.getField("respondent");
 
        // const c1 = form.getField("case_number");
        // const c2 = form.getField("case_number_1");
        // const c3 = form.getField("case_number_2");
 
        // Group all fields
        const allFields = [p1, p2, p3, r1, r2, r3];
 
        // Set default appearance for all fields
        allFields.forEach(field => {
            field.defaultUpdateAppearances(helveticaFont);
            field.setFontSize(10);
        });
        // Set text values (safely)
        if (petitionerDetails) {
            const fullPetName = `${petitionerDetails.firstName} ${petitionerDetails.lastName}`;
            p1.setText(fullPetName);
            p2.setText(fullPetName);
            p3.setText(fullPetName);
        }

        if (respondentDetails) {
            const fullRespName = `${respondentDetails.firstName} ${respondentDetails.lastName}`;
            r1.setText(fullRespName);
            r2.setText(fullRespName);
            r3.setText(fullRespName);
        }

        if (courtDetails && courtDetails.caseNumber) {
            const caseNum = courtDetails.caseNumber.toString();
            form.getField("case_number").setText(caseNum);
            form.getField("case_number_1").setText(caseNum);
            form.getField("case_number_2").setText(caseNum);
        }

         // Check checkbox
        form.getCheckBox("checkbox_2").check();
        
        
        props.printout === "1" ? form.getCheckBox("printout_checkbox").check() : form.getCheckBox("printout_checkbox").uncheck();

        props.printout === "0" ? form.getCheckBox("income_checkbox").check() : form.getCheckBox("income_checkbox").uncheck();

        if (form.getCheckBox("income_checkbox").isChecked()) {
            form.getField("gross_petitional_1").setText(props.income.petitioner_gmi);
            form.getField("gross_petitional_2").setText(props.income.respondent_gmi);
            form.getField("gross_petitional_3").setText(props.income.other_gmi);
            form.getField("net_income_1").setText(props.income.petitioner_nmi);
            form.getField("net_income_2").setText(props.income.respondent_nmi);
            form.getField("net_income_3").setText(props.income.other_nmi);

            if (BoxesIncome.includes("1") && form.getCheckBox("income_checkbox").isChecked()) {
                form.getCheckBox("receiving_check_1").check();
            } else {
                form.getCheckBox("receiving_check_1").uncheck();
            }
            if (BoxesIncome.includes("2") && form.getCheckBox("income_checkbox").isChecked()) {
                form.getCheckBox("receiving_check_2").check();
            } else {
                form.getCheckBox("receiving_check_2").uncheck();
            }
            if (BoxesIncome.includes("3") && form.getCheckBox("income_checkbox").isChecked()) {
                form.getCheckBox("receiving_check_3").check();
            } else {
                form.getCheckBox("receiving_check_3").uncheck();
            }


            if (BoxesIncomeB.includes("1") && form.getCheckBox("income_checkbox").isChecked()) {
                form.getCheckBox("earning_check_1").check();
            } else {
                form.getCheckBox("earning_check_1").uncheck();
            }
            if (BoxesIncomeB.includes("2") && form.getCheckBox("income_checkbox").isChecked()) {
                form.getCheckBox("earning_check_2").check();
            } else {
                form.getCheckBox("earning_check_2").uncheck();
            }
            if (BoxesIncomeB.includes("3") && form.getCheckBox("income_checkbox").isChecked()) {
                form.getCheckBox("earning_check_3").check();
            } else {
                form.getCheckBox("earning_check_3").uncheck();
            }

            (!isEmpty(props.income) && !isUndefined(props.income)) && form.getField("earning_text_1").setText(props.income.income_b_number.toString());
            (!isEmpty(props.income) && !isUndefined(props.income)) && form.getField("earning_text_2").setText(props.income.income_b_number.toString());
            (!isEmpty(props.income) && !isUndefined(props.income)) && form.getField("earning_text_3").setText(props.income.income_b_number.toString());

        } else {
            form.getField("gross_petitional_1").setText("");
            form.getField("gross_petitional_2").setText("");
            form.getField("gross_petitional_3").setText("");
            form.getField("net_income_1").setText("");
            form.getField("net_income_2").setText("");
            form.getField("net_income_3").setText("");
            form.getCheckBox("receiving_check_1").uncheck();
            form.getCheckBox("receiving_check_2").uncheck();
            form.getCheckBox("earning_check_1").uncheck();
            form.getCheckBox("earning_check_2").uncheck();
            form.getCheckBox("earning_check_3").uncheck();
            form.getField("earning_text_1").setText("")
            form.getField("earning_text_2").setText("")
            form.getField("earning_text_3").setText("")
        }

        props.printout === "0" ? form.getCheckBox("child_relation_checkbox").check() : form.getCheckBox("child_relation_checkbox").uncheck();

        if ((!isEmpty(props.children) && !isUndefined(props.children))) {
            form.getCheckBox("child_relation_checkbox").isChecked()
            form.getField("child_text_2").setText((props.children.children_b_plaintiff).toString());
            form.getField("child_text_3").setText((props.children.children_b_respondent).toString());
            form.getField("child_text_4").setText((props.children.children_b_other).toString());
            form.getField("child_text_1").setText((props.children.children_a_text).toString());

        } else {
            form.getField("child_text_2").setText("");
            form.getField("child_text_3").setText("");
            form.getField("child_text_4").setText("");
            form.getField("child_text_1").setText("");
        }

        props.printout === "0" || props.printout === "-1" ? form.getCheckBox("hardship_checkbox").check() : form.getCheckBox("hardship_checkbox").uncheck();


        if (BoxesHardship.includes("1") && form.getCheckBox("hardship_checkbox").isChecked()) {
            form.getCheckBox("hardship_checkbox_1").check();
        } else {
            form.getCheckBox("hardship_checkbox_1").uncheck();
        }
        if (BoxesHardship.includes("2") && form.getCheckBox("hardship_checkbox").isChecked()) {
            form.getCheckBox("hardship_checkbox_2").check();
        } else {
            form.getCheckBox("hardship_checkbox_2").uncheck();
        }
        if (BoxesHardship.includes("3") && form.getCheckBox("hardship_checkbox").isChecked()) {
            form.getCheckBox("hardship_checkbox_3").check();
        } else {
            form.getCheckBox("hardship_checkbox_3").uncheck();
        }

        if (form.getCheckBox("hardship_checkbox_1").isChecked()) {
            form.getField("hardship_petitioner_1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).petitioner_plaintiff.toString() : '');
            form.getField("hardship_respondent_1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).respondent_defendent.toString() : '');
            form.getField("hardship_other_1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).other_parent.toString() : '');
            form.getField("hardship_approx_1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).end_time_hardship.toString() : '');
        } else {
            form.getField("hardship_petitioner_1").setText("");
            form.getField("hardship_respondent_1").setText("");
            form.getField("hardship_other_1").setText("");
            form.getField("hardship_approx_1").setText("");

        }

        if (form.getCheckBox("hardship_checkbox_2").isChecked()) {
            form.getField("hardship_petitioner_2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).petitioner_plaintiff.toString() : '');
            form.getField("hardship_respondent_2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).respondent_defendent.toString() : '');
            form.getField("hardship_other_2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).other_parent.toString() : '');
            form.getField("hardship_approx_2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).end_time_hardship.toString() : '');
        } else {
            form.getField("hardship_petitioner_2").setText("");
            form.getField("hardship_respondent_2").setText("");
            form.getField("hardship_other_2").setText("");
            form.getField("hardship_approx_2").setText("");

        }

        if (form.getCheckBox("hardship_checkbox_3").isChecked()) {
            form.getField("hardship_petitioner_3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).petitioner_plaintiff.toString() : '');
            form.getField("hardship_respondent_3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).respondent_defendent.toString() : '');
            form.getField("hardship_other_3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).other_parent.toString() : '');
            form.getField("hardship_approx_3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).end_time_hardship.toString() : '');
        } else {
            form.getField("hardship_petitioner_3").setText("");
            form.getField("hardship_respondent_3").setText("");
            form.getField("hardship_other_3").setText("");
            form.getField("hardship_approx_3").setText("");

        }


        if (props.low_income.lowincome === "1" || props.low_income.lowincomeApply === "1") {
            form.getCheckBox("lowincome_checkbox_1").check();
        } else {
            form.getCheckBox("lowincome_checkbox_1").uncheck();
        }
        props.low_income.lowincome === "1" ? form.getCheckBox("lowincome_checkbox_2").check() : form.getCheckBox("lowincome_checkbox_2").uncheck();
        props.low_income.lowincomeApply === "1" ? form.getCheckBox("lowincome_checkbox_3").check() : form.getCheckBox("lowincome_checkbox_3").uncheck();

        if (Boxes.includes("1")) {
            form.getCheckBox("base_childsupport_petitioner").check();
        } else {
            form.getCheckBox("base_childsupport_petitioner").uncheck();
        }

        if (Boxes.includes("2")) {
            form.getCheckBox("base_childsupport_respondent").check();
        } else {
            form.getCheckBox("base_childsupport_respondent").uncheck();
        }

        if (Boxes.includes("3")) {
            form.getCheckBox("base_childsupport_other").check();
        } else {
            form.getCheckBox("base_childsupport_other").uncheck();
        }
        !isEmpty(props.child_support.base_child_support_date) && form.getField("child_date").setText(parseDate(props.child_support.base_child_support_date));

        if (inputFields.length > 0) {
            form.getCheckBox("childsupport_checkbox").check();
        }

        !isEmpty(inputFields) && inputFields.forEach((eachInput, index) => {
            form.getField(`child_name_${index+1}`).setText(eachInput.child_name);
            form.getField(`child_dob_${index+1}`).setText(parseDate(eachInput.child_dob));
            form.getField(`child_monthly_amount_${index+1}`).setText(eachInput.monthly_amount.toString());
            form.getField(`child_payable_to_${index+1}`).setText(eachInput.payable_name);
        });

        if (!isEmpty(props.child_support.base_child_support_other_text)) {
            form.getCheckBox("base_childsupport_other_specify").check();
            !isUndefined(props.child_support.base_child_support_other_text) && form.getField("childsupport_other").setText(props.child_support.base_child_support_other_text);
        } else {
            form.getCheckBox("base_childsupport_other_specify").uncheck();
            form.getField("childsupport_other").setText("");
        }

        if (Boxes2.includes("1")) {
            form.getCheckBox("base_childsupport_payable").check();
        } else {
            form.getCheckBox("base_childsupport_payable").uncheck();
        }


        if (!isEmpty(props.mandatory_child_support.ChildPetitionerTotal)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("madatory_checkbox_1").check();
            form.getField("mandotary_text_1").setText(props.mandatory_child_support.ChildPetitionerTotal);
        }
        if (!isEmpty(props.mandatory_child_support.ChildPetitionerMonth)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("madatory_checkbox_1").check();
            form.getCheckBox("madatory_checkbox_5").check();
            form.getField("mandotary_text_4").setText(props.mandatory_child_support.ChildPetitionerMonth);
        }


        if (!isEmpty(props.mandatory_child_support.ChildRespondentTotal)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("madatory_checkbox_2").check();
            form.getField("mandotary_text_2").setText(props.mandatory_child_support.ChildRespondentTotal);
        }
        if (!isEmpty(props.mandatory_child_support.ChildRespondentMonth)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("madatory_checkbox_2").check();
            form.getCheckBox("madatory_checkbox_6").check();
            form.getField("mandotary_text_5").setText(props.mandatory_child_support.ChildRespondentMonth);
        }


        if (!isEmpty(props.mandatory_child_support.ChildOtherTotal)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("madatory_checkbox_3").check();
            form.getField("mandotary_text_3").setText(props.mandatory_child_support.ChildOtherTotal);
        }
        if (!isEmpty(props.mandatory_child_support.ChildOtherMonth)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("madatory_checkbox_3").check();
            form.getCheckBox("madatory_checkbox_7").check();
            form.getField("mandotary_text_6").setText(props.mandatory_child_support.ChildOtherMonth);
        }


        if (!isEmpty(props.mandatory_child_support.ChildCostSpecify)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("madatory_checkbox_4").check();
            form.getField("mandotary_text_7").setText(props.mandatory_child_support.ChildCostSpecify);
        }



        if (!isEmpty(props.mandatory_child_support.ReasonPetitionerTotal)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("reasonable_checkbox_1").check();
            form.getField("reasonable_text_1").setText(props.mandatory_child_support.ReasonPetitionerTotal);
        }
        if (!isEmpty(props.mandatory_child_support.ReasonPetitionerMonth)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("reasonable_checkbox_1").check();
            form.getCheckBox("reasonable_checkbox_5").check();
            form.getField("reasonable_text_4").setText(props.mandatory_child_support.ReasonPetitionerMonth);
        }



        if (!isEmpty(props.mandatory_child_support.ReasonRespondentTotal)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("reasonable_checkbox_2").check();
            form.getField("reasonable_text_2").setText(props.mandatory_child_support.ReasonRespondentTotal);
        }
        if (!isEmpty(props.mandatory_child_support.ReasonRespondentMonth)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("reasonable_checkbox_2").check();
            form.getCheckBox("reasonable_checkbox_6").check();
            form.getField("reasonable_text_5").setText(props.mandatory_child_support.ReasonRespondentMonth);
        }


        if (!isEmpty(props.mandatory_child_support.ReasonOtherTotal)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("reasonable_checkbox_3").check();
            form.getField("reasonable_text_3").setText(props.mandatory_child_support.ReasonOtherTotal);
        }
        if (!isEmpty(props.mandatory_child_support.ReasonOtherMonth)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("reasonable_checkbox_3").check();
            form.getCheckBox("reasonable_checkbox_7").check();
            form.getField("reasonable_text_6").setText(props.mandatory_child_support.ReasonOtherMonth);
        }


        if (!isEmpty(props.mandatory_child_support.ReasonCostSpecify)) {
            form.getCheckBox("mandatory_childsupport_checkbox").check();
            form.getCheckBox("reasonable_checkbox_4").check();
            form.getField("reasonable_text_7").setText(props.mandatory_child_support.ReasonCostSpecify);
        }

        if (!isEmpty(props.additional_child_support.CostPetitionerTotal)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_1").check();
            form.getCheckBox("cost_checkbox_1").check();
            form.getField("cost_text_1").setText(props.additional_child_support.CostPetitionerTotal);
        }
        if (!isEmpty(props.additional_child_support.CostPetitionerMonth)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_1").check();
            form.getCheckBox("cost_checkbox_1").check();
            form.getCheckBox("cost_checkbox_5").check();
            form.getField("cost_text_4").setText(props.additional_child_support.CostPetitionerMonth);
        }


        if (!isEmpty(props.additional_child_support.CostRespondentTotal)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_1").check();
            form.getCheckBox("cost_checkbox_2").check();
            form.getField("cost_text_2").setText(props.additional_child_support.CostRespondentTotal);
        }
        if (!isEmpty(props.additional_child_support.CostRespondentMonth)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_1").check();
            form.getCheckBox("cost_checkbox_2").check();
            form.getCheckBox("cost_checkbox_6").check();
            form.getField("cost_text_5").setText(props.additional_child_support.CostRespondentMonth);
        }


        if (!isEmpty(props.additional_child_support.CostOtherTotal)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_1").check();
            form.getCheckBox("cost_checkbox_3").check();
            form.getField("cost_text_3").setText(props.additional_child_support.CostOtherTotal);
        }
        if (!isEmpty(props.additional_child_support.CostOtherMonth)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_1").check();
            form.getCheckBox("cost_checkbox_3").check();
            form.getCheckBox("cost_checkbox_7").check();
            form.getField("cost_text_6").setText(props.additional_child_support.CostOtherMonth);
        }


        if (!isEmpty(props.additional_child_support.CostCostSpecify)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_1").check();
            form.getCheckBox("cost_checkbox_4").check();
            form.getField("cost_text_7").setText(props.additional_child_support.CostCostSpecify);
        }




        if (!isEmpty(props.additional_child_support.TravelPetitionerTotal)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_2").check();
            form.getCheckBox("travel_checkbox_1").check();
            form.getField("cost_text_1").setText(props.additional_child_support.TravelPetitionerTotal);
        }
        if (!isEmpty(props.additional_child_support.TravelPetitionerMonth)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_2").check();
            form.getCheckBox("travel_checkbox_1").check();
            form.getCheckBox("cost_checkbox_5").check();
            form.getField("cost_text_4").setText(props.additional_child_support.TravelPetitionerMonth);
        }


        if (!isEmpty(props.additional_child_support.TravelRespondentTotal)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_2").check();
            form.getCheckBox("travel_checkbox_2").check();
            form.getField("travel_text_2").setText(props.additional_child_support.TravelRespondentTotal);
        }
        if (!isEmpty(props.additional_child_support.TravelRespondentMonth)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_2").check();
            form.getCheckBox("travel_checkbox_2").check();
            form.getCheckBox("travel_checkbox_6").check();
            form.getField("travel_text_5").setText(props.additional_child_support.TravelRespondentMonth);
        }


        if (!isEmpty(props.additional_child_support.TravelOtherTotal)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_2").check();
            form.getCheckBox("travel_checkbox_3").check();
            form.getField("travel_text_3").setText(props.additional_child_support.TravelOtherTotal);
        }
        if (!isEmpty(props.additional_child_support.TravelOtherMonth)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_2").check();
            form.getCheckBox("travel_checkbox_3").check();
            form.getCheckBox("travel_checkbox_7").check();
            form.getField("travel_text_6").setText(props.additional_child_support.TravelOtherMonth);
        }


        if (!isEmpty(props.additional_child_support.TravelCostSpecify)) {
            form.getCheckBox("additional_childsupport_checkbox").check();
            form.getCheckBox("additional_childsupport_checkbox_2").check();
            form.getCheckBox("travel_checkbox_4").check();
            form.getField("travel_text_7").setText(props.additional_child_support.TravelCostSpecify);
        }


        props.guidelineSupport === "1" ? form.getCheckBox("non_guideline_checkbox_1").check() : form.getCheckBox("non_guideline_checkbox_1").uncheck();


        if (HealthInsuranceBoxes.includes("1")) {
            form.getCheckBox("healthcare_checkbox_1").check()
        } else {
            form.getCheckBox("healthcare_checkbox_1").uncheck()
        }

        if (HealthInsuranceBoxes.includes("2")) {
            form.getCheckBox("healthcare_checkbox_2").check()
        } else {
            form.getCheckBox("healthcare_checkbox_2").uncheck()
        }

        if (HealthInsuranceBoxes.includes("3")) {
            form.getCheckBox("healthcare_checkbox_3").check()
        } else {
            form.getCheckBox("healthcare_checkbox_3").uncheck()
        }



        if (HealthInsuranceNotAvailBoxes.includes("1") || (HealthInsuranceNotAvailBoxes.includes("2")) || (HealthInsuranceNotAvailBoxes.includes("3"))) {
            form.getCheckBox("healthcare_checkbox_4").check()
        } else {
            form.getCheckBox("healthcare_checkbox_4").uncheck()
        }

        if (HealthInsuranceNotAvailBoxes.includes("1")) {
            form.getCheckBox("healthcare_checkbox_5").check()
        } else {
            form.getCheckBox("healthcare_checkbox_5").uncheck()
        }

        if (HealthInsuranceNotAvailBoxes.includes("2")) {
            form.getCheckBox("healthcare_checkbox_6").check()
        } else {
            form.getCheckBox("healthcare_checkbox_6").uncheck()
        }

        if (HealthInsuranceNotAvailBoxes.includes("3")) {
            form.getCheckBox("healthcare_checkbox_7").check()
        } else {
            form.getCheckBox("healthcare_checkbox_7").uncheck()
        }

        props.health_care_expenses.health_care_expenses_c == "1" ? form.getCheckBox("healthcare_checkbox_8").check() : form.getCheckBox("healthcare_checkbox_8").uncheck()


        if (!isEmpty(EmploymentSearchBoxes)) {
            form.getCheckBox("employee_checkbox").check();
        } else {
            form.getCheckBox("employee_checkbox").uncheck();

        }


        if (EmploymentSearchBoxes.includes("1")) {
            form.getCheckBox("employee_checkbox_1").check();

        } else {
            form.getCheckBox("employee_checkbox_1").uncheck();

        }

        if (EmploymentSearchBoxes.includes("2")) {
            form.getCheckBox("employee_checkbox_2").check();

        } else {
            form.getCheckBox("employee_checkbox_2").uncheck();

        }

        if (EmploymentSearchBoxes.includes("3")) {
            form.getCheckBox("employee_checkbox_3").check();

        } else {
            form.getCheckBox("employee_checkbox_3").uncheck();

        }
        (!isEmpty(props.employment_search_order.employment_search_order_text) && !isUndefined(props.employment_search_order.employment_search_order_text)) && form.getField("employee_condition").setText(props.employment_search_order.employment_search_order_text);

        !isUndefined(props.other_orders_text) && form.getField("other_orders").setText(props.other_orders_text);
        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");

    }
    // async function myFunction() {
    //     const existingPdfBytes = await fetch(`${serverApi}/FL-342`, {
    //         headers: {
    //             Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
    //         },
    //     }).then((res) => res.arrayBuffer());
    //     var bytes = new Uint8Array(existingPdfBytes);
    //     const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
    //     const form = pdfDoc.getForm();

    //     let valueAmount = 0;

    //     !isEmpty(props.child_support.childDetail) && props.child_support.childDetail.map((amount) => {
    //         valueAmount = Number(valueAmount) + Number(amount.monthly_amount);
    //     })

    //     form.getField("tcsPerMonth").setText(valueAmount.toString());


    //     !isUndefined(petitionerDetails) && form.getField("chPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    //     !isUndefined(respondentDetails) && form.getField("chRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    //     !isUndefined(courtDetails) && form.getField("chCaseNumber").setText(courtDetails.caseNumber.toString());

    //     form.getCheckBox("form1").check();


    //     !isUndefined(petitionerDetails) && form.getField("cfPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    //     !isUndefined(respondentDetails) && form.getField("cfRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    //     !isUndefined(courtDetails) && form.getField("cfCaseNumber").setText(courtDetails.caseNumber.toString());

    //     !isUndefined(petitionerDetails) && form.getField("eaPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    //     !isUndefined(respondentDetails) && form.getField("eaRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    //     !isUndefined(courtDetails) && form.getField("eaCaseNumber").setText(courtDetails.caseNumber.toString());





    //     props.printout === "1" ? form.getCheckBox("acsCalculation").check() : form.getCheckBox("acsCalculation").uncheck();

    //     props.printout === "0" ? form.getCheckBox("acsIncome").check() : form.getCheckBox("acsIncome").uncheck();

    //     if (form.getCheckBox("acsIncome").isChecked()) {
    //         form.getField("gm1").setText(props.income.petitioner_gmi);
    //         form.getField("gm2").setText(props.income.respondent_gmi);
    //         form.getField("gm3").setText(props.income.other_gmi);
    //         form.getField("nm1").setText(props.income.petitioner_nmi);
    //         form.getField("nm2").setText(props.income.respondent_nmi);
    //         form.getField("nm3").setText(props.income.other_nmi);

    //         if (BoxesIncome.includes("1") && form.getCheckBox("acsIncome").isChecked()) {
    //             form.getCheckBox("receiving1").check();
    //         } else {
    //             form.getCheckBox("receiving1").uncheck();
    //         }
    //         if (BoxesIncome.includes("2") && form.getCheckBox("acsIncome").isChecked()) {
    //             form.getCheckBox("receiving2").check();
    //         } else {
    //             form.getCheckBox("receiving2").uncheck();
    //         }
    //         if (BoxesIncome.includes("3") && form.getCheckBox("acsIncome").isChecked()) {
    //             form.getCheckBox("receiving3").check();
    //         } else {
    //             form.getCheckBox("receiving3").uncheck();
    //         }


    //         if (BoxesIncomeB.includes("1") && form.getCheckBox("acsIncome").isChecked()) {
    //             form.getCheckBox("incPetitionor").check();
    //         } else {
    //             form.getCheckBox("incPetitionor").uncheck();
    //         }
    //         if (BoxesIncomeB.includes("2") && form.getCheckBox("acsIncome").isChecked()) {
    //             form.getCheckBox("incRespondent").check();
    //         } else {
    //             form.getCheckBox("incRespondent").uncheck();
    //         }
    //         if (BoxesIncomeB.includes("3") && form.getCheckBox("acsIncome").isChecked()) {
    //             form.getCheckBox("incOther").check();
    //         } else {
    //             form.getCheckBox("incOther").uncheck();
    //         }

    //         (!isEmpty(props.income) && !isUndefined(props.income)) && form.getField("incAmount").setText(props.income.income_b_number.toString());
    //         (!isEmpty(props.income) && !isUndefined(props.income)) && form.getField("incImputed").setText(props.income.income_b_text.toString());

    //     } else {
    //         form.getField("gm1").setText("");
    //         form.getField("gm2").setText("");
    //         form.getField("gm3").setText("");
    //         form.getField("nm1").setText("");
    //         form.getField("nm2").setText("");
    //         form.getField("nm3").setText("");
    //         form.getCheckBox("receiving1").uncheck();
    //         form.getCheckBox("receiving2").uncheck();
    //         form.getCheckBox("incPetitionor").uncheck();
    //         form.getCheckBox("incRespondent").uncheck();
    //         form.getCheckBox("incOther").uncheck();
    //         form.getField("incAmount").setText("")
    //         form.getField("incImputed").setText("")
    //     }

    //     props.printout === "0" ? form.getCheckBox("childRelation").check() : form.getCheckBox("childRelation").uncheck();

    //     if ((!isEmpty(props.children) && !isUndefined(props.children))) {
    //         form.getCheckBox("childRelation").isChecked()
    //         form.getField("approximatePet").setText(props.children.children_b_plaintiff);
    //         form.getField("approximateRes").setText(props.children.children_b_respondent);
    //         form.getField("approximateOther").setText(props.children.children_b_other);
    //         form.getField("childSpec").setText(props.children.children_a_text);

    //     } else {
    //         form.getField("approximatePet").setText("");
    //         form.getField("approximateRes").setText("");
    //         form.getField("approximateOther").setText("");
    //         form.getField("childSpec").setText("");
    //     }

    //     props.printout === "0" || props.printout === "-1" ? form.getCheckBox("hardsShips").check() : form.getCheckBox("hardsShips").uncheck();


    //     if (BoxesHardship.includes("1") && form.getCheckBox("hardsShips").isChecked()) {
    //         form.getCheckBox("hsChild").check();
    //     } else {
    //         form.getCheckBox("hsChild").uncheck();
    //     }
    //     if (BoxesHardship.includes("2") && form.getCheckBox("hardsShips").isChecked()) {
    //         form.getCheckBox("hsExpense").check();
    //     } else {
    //         form.getCheckBox("hsExpense").uncheck();
    //     }
    //     if (BoxesHardship.includes("3") && form.getCheckBox("hardsShips").isChecked()) {
    //         form.getCheckBox("hsLosses").check();
    //     } else {
    //         form.getCheckBox("hsLosses").uncheck();
    //     }

    //     if (form.getCheckBox("hsChild").isChecked()) {
    //         form.getField("pp1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).petitioner_plaintiff.toString() : '');
    //         form.getField("rd1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).respondent_defendent.toString() : '');
    //         form.getField("op1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).other_parent.toString() : '');
    //         form.getField("aet1").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).end_time_hardship.toString() : '');
    //     } else {
    //         form.getField("pp1").setText("");
    //         form.getField("rd1").setText("");
    //         form.getField("op1").setText("");
    //         form.getField("aet1").setText("");

    //     }

    //     if (form.getCheckBox("hsExpense").isChecked()) {
    //         form.getField("pp2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).petitioner_plaintiff.toString() : '');
    //         form.getField("rd2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).respondent_defendent.toString() : '');
    //         form.getField("op2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).other_parent.toString() : '');
    //         form.getField("aet2").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).end_time_hardship.toString() : '');
    //     } else {
    //         form.getField("pp2").setText("");
    //         form.getField("rd2").setText("");
    //         form.getField("op2").setText("");
    //         form.getField("aet2").setText("");

    //     }

    //     if (form.getCheckBox("hsLosses").isChecked()) {
    //         form.getField("pp3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).petitioner_plaintiff.toString() : '');
    //         form.getField("rd3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).respondent_defendent.toString() : '');
    //         form.getField("op3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).other_parent.toString() : '');
    //         form.getField("aet3").setText(size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).end_time_hardship.toString() : '');
    //     } else {
    //         form.getField("pp3").setText("");
    //         form.getField("rd3").setText("");
    //         form.getField("op3").setText("");
    //         form.getField("aet3").setText("");

    //     }


    //     if (props.low_income.lowincome === "1" || props.low_income.lowincomeApply === "1") {
    //         form.getCheckBox("lowInc").check();
    //     } else {
    //         form.getCheckBox("lowInc").uncheck();
    //     }
    //     props.low_income.lowincome === "1" ? form.getCheckBox("lowApplies").check() : form.getCheckBox("lowApplies").uncheck()
    //     props.low_income.lowincomeApply === "1" ? form.getCheckBox("lowIncNot").check() : form.getCheckBox("lowIncNot").uncheck()

    //     if (form.getCheckBox("lowIncNot").isChecked()) {
    //         (!isEmpty(props.low_income.low_income_text) && !isUndefined(props.low_income)) && form.getField("lowSpec").setText(props.low_income.low_income_text);
    //     } else {
    //         form.getField("lowSpec").setText();

    //     }

    //     if (Boxes.includes("1")) {
    //         form.getCheckBox("bcsPet").check();
    //     } else {
    //         form.getCheckBox("bcsPet").uncheck();
    //     }

    //     if (Boxes.includes("2")) {
    //         form.getCheckBox("bcsRes").check();
    //     } else {
    //         form.getCheckBox("bcsRes").uncheck();
    //     }

    //     if (Boxes.includes("3")) {
    //         form.getCheckBox("bcsOther").check();
    //     } else {
    //         form.getCheckBox("bcsOther").uncheck();
    //     }
    //     !isEmpty(props.child_support.base_child_support_date) && form.getField("bcsDate").setText(parseDate(props.child_support.base_child_support_date));

    //     if (inputFields.length > 0) {
    //         form.getCheckBox("ChildSupport").check();
    //     }

    //     !isEmpty(inputFields) && inputFields.forEach((eachInput, index) => {
    //         form.getField(`cn${index}`).setText(eachInput.child_name);
    //         form.getField(`dob${index}`).setText(parseDate(eachInput.child_dob));
    //         form.getField(`mm${index}`).setText(eachInput.monthly_amount.toString());
    //         form.getField(`payable${index}`).setText(eachInput.payable_name);
    //     });

    //     if (!isEmpty(props.child_support.base_child_support_other_text)) {
    //         form.getCheckBox("pay2").check();
    //         !isUndefined(props.child_support.base_child_support_other_text) && form.getField("payableOther").setText(props.child_support.base_child_support_other_text);
    //     } else {
    //         form.getCheckBox("pay2").uncheck();
    //         form.getField("payableOther").setText("");
    //     }

    //     if (Boxes2.includes("1")) {
    //         form.getCheckBox("pay0").check();
    //     } else {
    //         form.getCheckBox("pay0").uncheck();
    //     }

    //     if (Boxes2.includes("2")) {
    //         form.getCheckBox("pay1").check();
    //     } else {
    //         form.getCheckBox("pay1").uncheck();
    //     }


    //     if (!isEmpty(props.mandatory_child_support.ChildPetitionerTotal)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("cfPet").check();
    //         form.getField("cf1").setText(props.mandatory_child_support.ChildPetitionerTotal);
    //     }
    //     if (!isEmpty(props.mandatory_child_support.ChildPetitionerMonth)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("cfPet").check();
    //         form.getCheckBox("per1").check();
    //         form.getField("amount1").setText(props.mandatory_child_support.ChildPetitionerMonth);
    //     }


    //     if (!isEmpty(props.mandatory_child_support.ChildRespondentTotal)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("cfRes").check();
    //         form.getField("cf2").setText(props.mandatory_child_support.ChildRespondentTotal);
    //     }
    //     if (!isEmpty(props.mandatory_child_support.ChildRespondentMonth)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("cfRes").check();
    //         form.getCheckBox("per2").check();
    //         form.getField("amount2").setText(props.mandatory_child_support.ChildRespondentMonth);
    //     }


    //     if (!isEmpty(props.mandatory_child_support.ChildOtherTotal)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("cfOther").check();
    //         form.getField("cf3").setText(props.mandatory_child_support.ChildOtherTotal);
    //     }
    //     if (!isEmpty(props.mandatory_child_support.ChildOtherMonth)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("cfOther").check();
    //         form.getCheckBox("per3").check();
    //         form.getField("amount3").setText(props.mandatory_child_support.ChildOtherMonth);
    //     }


    //     if (!isEmpty(props.mandatory_child_support.ChildCostSpecify)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("cfCost").check();
    //         form.getField("costPaid").setText(props.mandatory_child_support.ChildCostSpecify);
    //     }



    //     if (!isEmpty(props.mandatory_child_support.ReasonPetitionerTotal)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("maPet").check();
    //         form.getField("maPer1").setText(props.mandatory_child_support.ReasonPetitionerTotal);
    //     }
    //     if (!isEmpty(props.mandatory_child_support.ReasonPetitionerMonth)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("maPet").check();
    //         form.getCheckBox("macPer1").check();
    //         form.getField("maAmount1").setText(props.mandatory_child_support.ReasonPetitionerMonth);
    //     }



    //     if (!isEmpty(props.mandatory_child_support.ReasonRespondentTotal)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("maRes").check();
    //         form.getField("maPer2").setText(props.mandatory_child_support.ReasonRespondentTotal);
    //     }
    //     if (!isEmpty(props.mandatory_child_support.ReasonRespondentMonth)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("maRes").check();
    //         form.getCheckBox("macPer2").check();
    //         form.getField("maAmount2").setText(props.mandatory_child_support.ReasonRespondentMonth);
    //     }


    //     if (!isEmpty(props.mandatory_child_support.ReasonOtherTotal)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("maOther").check();
    //         form.getField("maPer3").setText(props.mandatory_child_support.ReasonOtherTotal);
    //     }
    //     if (!isEmpty(props.mandatory_child_support.ReasonOtherMonth)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("maOther").check();
    //         form.getCheckBox("macPer3").check();
    //         form.getField("maAmount3").setText(props.mandatory_child_support.ReasonOtherMonth);
    //     }


    //     if (!isEmpty(props.mandatory_child_support.ReasonCostSpecify)) {
    //         form.getCheckBox("cfMandatory").check();
    //         form.getCheckBox("maCost").check();
    //         form.getField("maCostPaid").setText(props.mandatory_child_support.ReasonCostSpecify);
    //     }

    //     if (!isEmpty(props.additional_child_support.CostPetitionerTotal)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("costRelated").check();
    //         form.getCheckBox("acPet").check();
    //         form.getField("acPer1").setText(props.additional_child_support.CostPetitionerTotal);
    //     }
    //     if (!isEmpty(props.additional_child_support.CostPetitionerMonth)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("costRelated").check();
    //         form.getCheckBox("acPet").check();
    //         form.getCheckBox("ac1").check();
    //         form.getField("acAmount1").setText(props.additional_child_support.CostPetitionerMonth);
    //     }


    //     if (!isEmpty(props.additional_child_support.CostRespondentTotal)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("costRelated").check();
    //         form.getCheckBox("acRes").check();
    //         form.getField("acPer2").setText(props.additional_child_support.CostRespondentTotal);
    //     }
    //     if (!isEmpty(props.additional_child_support.CostRespondentMonth)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("costRelated").check();
    //         form.getCheckBox("acRes").check();
    //         form.getCheckBox("ac2").check();
    //         form.getField("acAmount2").setText(props.additional_child_support.CostRespondentMonth);
    //     }


    //     if (!isEmpty(props.additional_child_support.CostOtherTotal)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("costRelated").check();
    //         form.getCheckBox("acOther").check();
    //         form.getField("acPer3").setText(props.additional_child_support.CostOtherTotal);
    //     }
    //     if (!isEmpty(props.additional_child_support.CostOtherMonth)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("costRelated").check();
    //         form.getCheckBox("acOther").check();
    //         form.getCheckBox("ac3").check();
    //         form.getField("acAmount3").setText(props.additional_child_support.CostOtherMonth);
    //     }


    //     if (!isEmpty(props.additional_child_support.CostCostSpecify)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("costRelated").check();
    //         form.getCheckBox("acCost").check();
    //         form.getField("acCostPaid").setText(props.additional_child_support.CostCostSpecify);
    //     }




    //     if (!isEmpty(props.additional_child_support.TravelPetitionerTotal)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("TravelExpense").check();
    //         form.getCheckBox("tePet").check();
    //         form.getField("tePer1").setText(props.additional_child_support.TravelPetitionerTotal);
    //     }
    //     if (!isEmpty(props.additional_child_support.TravelPetitionerMonth)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("TravelExpense").check();
    //         form.getCheckBox("tePet").check();
    //         form.getCheckBox("te1").check();
    //         form.getField("teAmount1").setText(props.additional_child_support.TravelPetitionerMonth);
    //     }


    //     if (!isEmpty(props.additional_child_support.TravelRespondentTotal)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("TravelExpense").check();
    //         form.getCheckBox("teRes").check();
    //         form.getField("tePer2").setText(props.additional_child_support.TravelRespondentTotal);
    //     }
    //     if (!isEmpty(props.additional_child_support.TravelRespondentMonth)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("TravelExpense").check();
    //         form.getCheckBox("teRes").check();
    //         form.getCheckBox("te2").check();
    //         form.getField("teAmount2").setText(props.additional_child_support.TravelRespondentMonth);
    //     }


    //     if (!isEmpty(props.additional_child_support.TravelOtherTotal)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("TravelExpense").check();
    //         form.getCheckBox("teOther").check();
    //         form.getField("tePer3").setText(props.additional_child_support.TravelOtherTotal);
    //     }
    //     if (!isEmpty(props.additional_child_support.TravelOtherMonth)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("TravelExpense").check();
    //         form.getCheckBox("teOther").check();
    //         form.getCheckBox("te3").check();
    //         form.getField("teAmount3").setText(props.additional_child_support.TravelOtherMonth);
    //     }


    //     if (!isEmpty(props.additional_child_support.TravelCostSpecify)) {
    //         form.getCheckBox("additionalChild").check();
    //         form.getCheckBox("TravelExpense").check();
    //         form.getCheckBox("teCost").check();
    //         form.getField("teCostPaid").setText(props.additional_child_support.TravelCostSpecify);
    //     }


    //     props.guidelineSupport === "1" ? form.getCheckBox("nonGuid").check() : form.getCheckBox("nonGuid").uncheck();


    //     if (HealthInsuranceBoxes.includes("1")) {
    //         form.getCheckBox("hcePet").check()
    //     } else {
    //         form.getCheckBox("hcePet").uncheck()
    //     }

    //     if (HealthInsuranceBoxes.includes("2")) {
    //         form.getCheckBox("hceRes").check()
    //     } else {
    //         form.getCheckBox("hceRes").uncheck()
    //     }

    //     if (HealthInsuranceBoxes.includes("3")) {
    //         form.getCheckBox("hceOther").check()
    //     } else {
    //         form.getCheckBox("hceOther").uncheck()
    //     }



    //     if (HealthInsuranceNotAvailBoxes.includes("1") || (HealthInsuranceNotAvailBoxes.includes("2")) || (HealthInsuranceNotAvailBoxes.includes("3"))) {
    //         form.getCheckBox("HealthInsurance").check()
    //     } else {
    //         form.getCheckBox("HealthInsurance").uncheck()
    //     }

    //     if (HealthInsuranceNotAvailBoxes.includes("1")) {
    //         form.getCheckBox("hiPet").check()
    //     } else {
    //         form.getCheckBox("hiPet").uncheck()
    //     }

    //     if (HealthInsuranceNotAvailBoxes.includes("2")) {
    //         form.getCheckBox("hiRes").check()
    //     } else {
    //         form.getCheckBox("hiRes").uncheck()
    //     }

    //     if (HealthInsuranceNotAvailBoxes.includes("3")) {
    //         form.getCheckBox("hiOther").check()
    //     } else {
    //         form.getCheckBox("hiOther").uncheck()
    //     }

    //     props.health_care_expenses.health_care_expenses_c == "1" ? form.getCheckBox("otherParty").check() : form.getCheckBox("otherParty").uncheck()


    //     if (!isEmpty(EmploymentSearchBoxes)) {
    //         form.getCheckBox("empOrder").check();
    //     } else {
    //         form.getCheckBox("empOrder").uncheck();

    //     }


    //     if (EmploymentSearchBoxes.includes("1")) {
    //         form.getCheckBox("empPet").check();

    //     } else {
    //         form.getCheckBox("empPet").uncheck();

    //     }

    //     if (EmploymentSearchBoxes.includes("2")) {
    //         form.getCheckBox("empRes").check();

    //     } else {
    //         form.getCheckBox("empRes").uncheck();

    //     }

    //     if (EmploymentSearchBoxes.includes("3")) {
    //         form.getCheckBox("empOther").check();

    //     } else {
    //         form.getCheckBox("empOther").uncheck();

    //     }
    //     (!isEmpty(props.employment_search_order.employment_search_order_text) && !isUndefined(props.employment_search_order.employment_search_order_text)) && form.getField("nocSpec").setText(props.employment_search_order.employment_search_order_text);

    //     !isUndefined(props.other_orders_text) && form.getField("otherOrder").setText(props.other_orders_text);
    //     // form.flatten();
    //     const pdfBytes = await pdfDoc.save();
    //     const pdfDataUrl = URL.createObjectURL(
    //         new Blob([pdfBytes], { type: "application/pdf" })
    //       );
    //       window.open(pdfDataUrl, "_blank");

    // }

    function saveByteArray(reportName, byte) {
        var blob = new Blob([byte], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    }


    function enableDisable(e, a, b, c, d) {

        var Number = document.getElementById(e);
        var textBox = document.getElementById(a);
        var textBoxB = document.getElementById(b);
        var textBoxC = document.getElementById(c);
        var textBoxD = document.getElementById(d);
        if (Number.checked) {

            textBox.removeAttribute("disabled")
            textBoxB.removeAttribute("disabled")
            textBoxC.removeAttribute("disabled")
            textBoxD.removeAttribute("disabled")
        }
        else {

            textBox.setAttribute("disabled", "true")
            textBoxB.setAttribute("disabled", "true")
            textBoxC.setAttribute("disabled", "true")
            textBoxD.setAttribute("disabled", "true")
        }

    }


    function controlEnableDisabled() {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.hardships) && get(props.hardships, `${y - 1}.fl_342_hardship_type_id`, "")
            z == `${y}` && cb.push(z == `${y}` ? `${y}` : "");
        });

        if (!isEmpty(cb) && cb.includes("1")) {
            document.getElementById("petitioner1").removeAttribute("disabled")
            document.getElementById("respondent1").removeAttribute("disabled")
            document.getElementById("otherParent1").removeAttribute("disabled")
            document.getElementById("endingTime1").removeAttribute("disabled")
        }
    }

    const classes = useStyles();

    useEffect(() => {
        props.getChildSupport({
            divorce_id: parseInt(window.localStorage.getItem("divorce_id")),
        });

        props.postData({ divorce_id: window.localStorage.getItem("divorce_id") });
        arrayCBOne();
        arrayCBTwo();
        arrayCBThree();
        arrayCBFour();
        arrayCBFive();
        arrayCBSix();
        arrayCBSeven();
        arrayCBEight();

    }, []);

    const [activeStep, setActiveStep] = React.useState(0);
    const [status, setStatus] = useState(true);
    const [lowIncome, setLowIncome] = useState(false);
    const [lowIncomeText, setLowIncomeText] = useState(false);
    const [guideline, setGuideline] = useState("0");
    const [healthCare, setHealthCare] = useState(false);

    const [inputFields, setInputField] = useState(isEmpty(props.child_support.childDetail) ? [{ child_name: "", child_dob: "", monthly_amount: "", payable_name: "" }] : props.child_support.childDetail);

    const [Boxes, setBoxes] = useState([]);
    const [Boxes2, setBoxes2] = useState([]);
    const [BoxesIncome, setBoxesIncome] = useState([]);
    const [BoxesIncomeB, setBoxesIncomeB] = useState([]);
    const [BoxesHardship, setBoxesHardship] = useState([]);

    const [MandatoryChildPayBoxes, setMandatoryChildPayBoxes] = useState([]);
    const [MandatoryChildPerBoxes, setMandatoryChildPerBoxes] = useState([]);
    const [MandatoryReasonablePayBoxes, setMandatoryReasonablePayBoxes] = useState([]);
    const [MandatoryReasonablePerBoxes, setMandatoryReasonablePerBoxes] = useState([]);

    const [AdditionalChildPayBoxes, setAdditionalChildPayBoxes] = useState([]);
    const [AdditionalChildPerBoxes, setAdditionalChildPerBoxes] = useState([]);
    const [AdditionalReasonablePayBoxes, setAdditionalReasonablePayBoxes] = useState([]);
    const [AdditionalReasonablePerBoxes, setAdditionalReasonablePerBoxes] = useState([]);

    const [HealthInsuranceBoxes, setHealthInsuranceBoxes] = useState([]);
    const [HealthInsuranceNotAvailBoxes, setHealthInsuranceNotAvailBoxes] = useState([]);

    const [EmploymentSearchBoxes, setEmploymentSearchBoxes] = useState([]);



    const steps = getSteps();

    function getCheckedValue(value) {
        if (Boxes.includes(value)) {
            let dummyArray = Boxes;
            remove(dummyArray, function (val) {
                return val === value;
            });
        } else {
            let dummyArray = Boxes;
            dummyArray.push(value);
            setBoxes(dummyArray);
        }
    }

    const arrayCBOne = () => {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.child_support.childCheckbox) && (props.child_support.childCheckbox).includes(`${y}`)
            z == true && cb.push(z == true ? `${y}` : "");
        });
        setBoxes(cb)
    }



    //All Form CheckBoxes Status
    function getSecondCheckedValue(value) {
        if (Boxes2.includes(value)) {
            let dummyArray1 = Boxes2;
            remove(dummyArray1, function (val) {
                return val === value;
            });
        } else {
            let dummyArray1 = Boxes2;
            dummyArray1.push(value);
            setBoxes2(dummyArray1);
        }
    }

    const arrayCBTwo = () => {
        let cb = [];
        forEach([1, 2], (y) => {
            let z = !isEmpty(props.child_support.payableCheckbox) && (props.child_support.payableCheckbox).includes(`${y}`)
            z == true && cb.push(z == true ? `${y}` : "");
        });
        setBoxes2(cb)
    }

    //Income CheckBoxes 

    function boxesIncome(value) {
        if (BoxesIncome.includes(value)) {
            let dummyArray1 = BoxesIncome;
            remove(dummyArray1, function (val) {
                return val === value;
            });
        } else {
            let dummyArray1 = BoxesIncome;
            dummyArray1.push(value);
            setBoxesIncome(dummyArray1);
        }
    }

    const arrayCBThree = () => {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.income.incomeCheckbox) && (props.income.incomeCheckbox).includes(`${y}`)
            z == true && cb.push(z == true ? `${y}` : "");
        });
        setBoxesIncome(cb)
    }

    //CheckBoxes 

    function boxesIncomeB(value) {
        if (BoxesIncomeB.includes(value)) {
            let dummyArray1 = BoxesIncomeB;
            remove(dummyArray1, function (val) {
                return val === value;
            });
        } else {
            let dummyArray1 = BoxesIncomeB;
            dummyArray1.push(value);
            setBoxesIncomeB(dummyArray1);
        }
    }

    const arrayCBFour = () => {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.income.imputationCheckbox) && (props.income.imputationCheckbox).includes(`${y}`)
            z == true && cb.push(z == true ? `${y}` : "");
        });
        setBoxesIncomeB(cb)
    }

    function boxesHardship(value) {
        if (BoxesHardship.includes(value)) {
            let dummyArray1 = BoxesHardship;
            remove(dummyArray1, function (val) {
                return val === value;
            });
        } else {
            let dummyArray1 = BoxesHardship;
            dummyArray1.push(value);
            setBoxesHardship(dummyArray1);
        }
    }

    const arrayCBEight = () => {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.hardships) && get(props.hardships, `${y - 1}.fl_342_hardship_type_id`, "")
            z == `${y}` && cb.push(z == `${y}` ? `${y}` : "");
        });
        setBoxesHardship(cb)
    }


    function boxesHealthInsurance(value) {
        if (HealthInsuranceBoxes.includes(value)) {
            let dummyArray1 = HealthInsuranceBoxes;
            remove(dummyArray1, function (val) {
                return val === value;
            });
        } else {
            let dummyArray1 = HealthInsuranceBoxes;
            dummyArray1.push(value);
            setHealthInsuranceBoxes(dummyArray1);
        }
    }

    const arrayCBFive = () => {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.health_care_expenses.health_care_expenses_available) && (props.health_care_expenses.health_care_expenses_available).includes(`${y}`)
            z == true && cb.push(z == true ? `${y}` : "");
        });
        setHealthInsuranceBoxes(cb)
    }


    function boxesHealthInsuranceNotAvail(value) {
        if (HealthInsuranceNotAvailBoxes.includes(value)) {
            let dummyArray1 = HealthInsuranceNotAvailBoxes;
            remove(dummyArray1, function (val) {
                return val === value;
            });
        } else {
            let dummyArray1 = HealthInsuranceNotAvailBoxes;
            dummyArray1.push(value);
            setHealthInsuranceNotAvailBoxes(dummyArray1);
        }
    }

    const arrayCBSix = () => {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.health_care_expenses.health_care_expenses_not) && (props.health_care_expenses.health_care_expenses_not).includes(`${y}`)
            z == true && cb.push(z == true ? `${y}` : "");
        });
        setHealthInsuranceNotAvailBoxes(cb)
    }

    function boxesEploymentSearch(value) {
        if (EmploymentSearchBoxes.includes(value)) {
            let dummyArray1 = EmploymentSearchBoxes;
            remove(dummyArray1, function (val) {
                return val === value;
            });
        } else {
            let dummyArray1 = EmploymentSearchBoxes;
            dummyArray1.push(value);
            setEmploymentSearchBoxes(dummyArray1);
        }
    }

    const arrayCBSeven = () => {
        let cb = [];
        forEach([1, 2, 3], (y) => {
            let z = !isEmpty(props.employment_search_order.employment_search_order_checkboxes) && (props.employment_search_order.employment_search_order_checkboxes).includes(`${y}`)
            z == true && cb.push(z == true ? `${y}` : "");
        });
        setEmploymentSearchBoxes(cb)
    }

    const handlePostFunction = () => {
        if (activeStep === 0) {
            props.putCourtUsed({
                divorce_id: window.localStorage.getItem("divorce_id"),
                printOut: document.getElementById("printout").value === "1" ?
                    (setActiveStep(
                        (prevActiveStep) => prevActiveStep === 0 && prevActiveStep + 3
                    ), document.getElementById("printout").value)

                    : document.getElementById("printout").value,
            })
        }

        else if (activeStep === 1) {
            props.putIncome({
                divorce_id: window.localStorage.getItem("divorce_id"),
                petitionerGmi: document.getElementById("petitioner-gmi").value,
                petitionerNmi: document.getElementById("petitioner-nmi").value,
                receivingTanf: BoxesIncome,
                respondentGmi: document.getElementById("respondent-gmi").value,
                respondentNmi: document.getElementById("respondent-nmi").value,
                otherGmi: document.getElementById("other-gmi").value,
                otherNmi: document.getElementById("other-nmi").value,
                fl342IncomeAId: BoxesIncomeB,
                amount: document.getElementById("income-b-number").value,
                perObject: document.getElementById("income-b-text").value,
            })
        }
        else if (activeStep === 2) {
            props.putChildren({
                divorce_id: window.localStorage.getItem("divorce_id"),
                fl342ChildrenRelationshipADescription: document.getElementById("children-a-text").value,
                petitionerPlaintiff: document.getElementById("children-b-plaintiff").value,
                respondentDefendent: document.getElementById("children-b-respondent").value,
                otherParent: document.getElementById("children-b-other").value,
            })
        }
        else if (activeStep === 3) {

            let dummyDataUpdate = [];
            forEach(BoxesHardship, function (value) {
                let y = {
                    divorce_id: window.localStorage.getItem("divorce_id"),
                    fl_342_hardship_type_id: value,
                    petitioner_plaintiff: document.getElementById(`petitioner${value}`).value,
                    respondent_defendent: document.getElementById(`respondent${value}`).value,
                    other_parent: document.getElementById(`otherParent${value}`).value,
                    end_time_hardship: document.getElementById(`endingTime${value}`).value,
                    fl_342_hardship_id: !isEmpty(props.hardships) && !isUndefined(props.hardships.find(x => x.fl_342_hardship_type_id == `${value}`)) && (props.hardships.find(x => x.fl_342_hardship_type_id == `${value}`).fl_342_hardship_id),
                }
                dummyDataUpdate.push(y);
            });
            if (!isEmpty(dummyDataUpdate)) {
                props.putHardships({
                    data: dummyDataUpdate,
                    divorce_id: window.localStorage.getItem("divorce_id"),
                })
            }
        }

        else if (activeStep === 4) {
            props.putLowIncome({
                divorce_id: window.localStorage.getItem("divorce_id"),
                adjustmentApplies: document.getElementById("lowincome").value,
            })
        }
        else if (activeStep === 5) {
            props.putChildSupport({
                divorce_id: window.localStorage.getItem("divorce_id"),
                mustPay: Boxes,
                payable: Boxes2,
                payableOther: document.getElementById("base-child-support-other-text").value,
                supportDate: document.getElementById("base-child-support-date").value,
                childDetails: !isEmpty(inputFields) && inputFields.map(v => ({
                    ...v,
                    fl_342_child_detail_id: v.fl_342_child_detail_id,
                    divorce_id: window.localStorage.getItem("divorce_id"),
                }))
            })
        }
        else if (activeStep === 6) {

            props.putMandatoryChildSupport({
                divorce_id: window.localStorage.getItem("divorce_id"),

                ChildPetitionerTotal: document.getElementById("childCarePay1").value,
                ChildPetitionerMonth: document.getElementById("childCarePer1").value,
                ChildRespondentTotal: document.getElementById("childCarePay2").value,
                ChildRespondentMonth: document.getElementById("childCarePer2").value,
                ChildOtherTotal: document.getElementById("childCarePay3").value,
                ChildOtherMonth: document.getElementById("childCarePer3").value,
                ChildCostSpecify: document.getElementById("child-care-cost-text").value,

                ReasonPetitionerTotal: document.getElementById("reasonablePay1").value,
                ReasonPetitionerMonth: document.getElementById("reasonablePer1").value,
                ReasonRespondentTotal: document.getElementById("reasonablePay2").value,
                ReasonRespondentMonth: document.getElementById("reasonablePer2").value,
                ReasonOtherTotal: document.getElementById("reasonablePay3").value,
                ReasonOtherMonth: document.getElementById("reasonablePer3").value,
                ReasonCostSpecify: document.getElementById("reasonable-cost-text").value,
            })
        }

        else if (activeStep === 7) {
            props.putAdditionalChildSupport({
                divorce_id: window.localStorage.getItem("divorce_id"),

                CostPetitionerTotal: document.getElementById("additionalCostPay1").value,
                CostPetitionerMonth: document.getElementById("additionalCostPer1").value,
                CostRespondentTotal: document.getElementById("additionalCostPay2").value,
                CostRespondentMonth: document.getElementById("additionalCostPer2").value,
                CostOtherTotal: document.getElementById("additionalCostPay3").value,
                CostOtherMonth: document.getElementById("additionalCostPer3").value,
                CostCostSpecify: document.getElementById("additional-child-support-cost-text").value,

                TravelPetitionerTotal: document.getElementById("additionalTravelPay1").value,
                TravelPetitionerMonth: document.getElementById("additionalTravelPer1").value,
                TravelRespondentTotal: document.getElementById("additionalTravelPay2").value,
                TravelRespondentMonth: document.getElementById("additionalTravelPer2").value,
                TravelOtherTotal: document.getElementById("additionalTravelPay3").value,
                TravelOtherMonth: document.getElementById("additionalTravelPer3").value,
                TravelCostSpecify: document.getElementById("additional-child-support-travel-cost-text").value,
            })
        }
        else if (activeStep === 8) {
            props.putNonGuidelineOrder({
                divorce_id: window.localStorage.getItem("divorce_id"),
                nonGuideline: document.getElementById("guidelineSupport").value,
            })
        }
        else if (activeStep === 9) {
            props.putHealthCareExpenses({
                divorce_id: window.localStorage.getItem("divorce_id"),
                partyProviding: document.getElementById("health-care-expenses-c").checked ? "1" : "0",
                healthInsuranceCoverage: HealthInsuranceBoxes,
                insuranceNotAvailable: HealthInsuranceNotAvailBoxes,
            })
        }
        else if (activeStep === 10) {
            props.putEmploymentSearchOrder({
                divorce_id: window.localStorage.getItem("divorce_id"),
                termCondition: document.getElementById("employment-search-order-text").value,
                fl342IncomeAId: EmploymentSearchBoxes,
            })
        }
        else if (activeStep === 11) {
            props.putOtherOrders({
                divorce_id: window.localStorage.getItem("divorce_id"),
                otherOrderDescription: document.getElementById("other-orders-text").value,
            })
        }
    }

    const handleChangeInput = (index, event) => {
        const values = [...inputFields];
        values[index][event.target.id] = event.target.value;
        setInputField(values);

    }

    const handleAddFields = () => {
        setInputField([...inputFields, { child_name: "", child_dob: "", monthly_amount: "", payable_name: "" }])
    }


    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputField(values);
    }

    const ColoredLine = ({ color }) => (
        <hr
            style={{
                borderTop: "2px solid",
                color: "black",
            }}
        />
    );


    const deleteCall = (index) => {
        props.deleteChildCall({
            divorce_id: window.localStorage.getItem("divorce_id"),
            fl_342_child_detail_id: props.child_support.childDetail != "" && get(props.child_support.childDetail, `${index}.fl_342_child_detail_id`, ""),

        })
    }




    function getStepContent(step) {
        switch (step) {
            case 0:
                return <div>
                    <Row>
                        <Col>
                            <h6>A printout of a computer calculation and findings is attached and
                                incorporated in this order for all required items not filled out below.</h6>

                            <h6 style={{ marginTop: "15px" }}>Will you include a support calculation printout and attach it to your MSA or forms?</h6>

                            <Input type="select" id="printout"
                                defaultValue={props.printout}>
                                <option selected value="-1"> -- select an option -- </option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </Input>
                        </Col>
                    </Row>
                </div>
            case 1:
                return <div>
                    <div>

                        <FormGroup>
                            <Row>
                                <Col lg="3" md="6" sm="12" style={{ textAlign: "center" }} >
                                    <h6 style={{ fontSize: "20px", fontStyle: "italic" }}>a. Each parent’s monthly income is as follows:</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12" style={{ textAlign: "center" }}>
                                    <h6><br></br>Gross monthly income</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12" style={{ textAlign: "center" }}>
                                    <h6><br></br>Net monthly income</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12" style={{ textAlign: "center" }}>
                                    <h6>Receiving TANF/CaIWORKS</h6>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row style={{ marginTop: "10px" }}>
                                <Col lg="3" md="6" sm="12">
                                    <h6 style={{ marginTop: "9px" }}>Petitioner/plaintiff:</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="number" id="petitioner-gmi" defaultValue={props.income.petitioner_gmi} />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="number" id="petitioner-nmi" defaultValue={props.income.petitioner_nmi} />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12" style={{ display: "flex", justifyContent: "center" }}>
                                    <Input type="checkbox" id="PetitionerCheck" value="1" style={{ height: "20px", width: "20px", marginTop: "10px" }}
                                        onChange={(e) => boxesIncome(e.target.value)}
                                        defaultChecked={size(props.income.incomeCheckbox.find(x => x === '1'))} />
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row style={{ marginTop: "10px" }}>
                                <Col lg="3" md="6" sm="12">
                                    <h6 style={{ marginTop: "9px" }}>Respondent/defendant:</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="number" id="respondent-gmi" defaultValue={props.income.respondent_gmi} />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="number" id="respondent-nmi" defaultValue={props.income.respondent_nmi} />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12" style={{ display: "flex", justifyContent: "center" }}>
                                    <Input type="checkbox" id="RespondentCheck" value="2" style={{ height: "20px", width: "20px", marginTop: "10px" }}
                                        onChange={(e) => boxesIncome(e.target.value)}
                                        defaultChecked={size(props.income.incomeCheckbox.find(x => x === '2'))} />
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row style={{ marginTop: "10px" }}>
                                <Col lg="3" md="6" sm="12">
                                    <h6 style={{ marginTop: "9px" }}>Other parent/party:</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="number" id="other-gmi" defaultValue={props.income.other_gmi} />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="number" id="other-nmi" defaultValue={props.income.other_nmi} />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12" style={{ display: "flex", justifyContent: "center" }}>
                                    <Input type="checkbox" id="OtherCheck" value="3" style={{ height: "20px", width: "20px", marginTop: "10px" }}
                                        onChange={(e) => boxesIncome(e.target.value)}
                                        defaultChecked={size(props.income.incomeCheckbox.find(x => x === '3'))} />
                                </Col>
                            </Row>
                        </FormGroup>


                        <Row>
                            <Col>
                                <h6 style={{ marginTop: "20px", fontSize: "20px", fontStyle: "italic" }}>b. Imputation of income. The court finds that the</h6>
                            </Col>
                        </Row>

                        <FormGroup style={{ marginLeft: "10px" }}>
                            <Row>
                                <Col lg="4" md="12" sm="12">
                                    <Input type="checkbox" id="bPetitionerCheck" value="1"
                                        onChange={(e) => boxesIncomeB(e.target.value)}
                                        defaultChecked={size(props.income.imputationCheckbox.find(x => x === '1'))} />
                                    <h6>Petitioner/plaintiff</h6>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <Input type="checkbox" id="bRespondentCheck" value="2"
                                        onChange={(e) => boxesIncomeB(e.target.value)}
                                        defaultChecked={size(props.income.imputationCheckbox.find(x => x === '2'))} />
                                    <h6>Respondent/defendant</h6>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <Input type="checkbox" id="bOtherCheck" value="3"
                                        onChange={(e) => boxesIncomeB(e.target.value)}
                                        defaultChecked={size(props.income.imputationCheckbox.find(x => x === '3'))} />
                                    <h6>Other parent/party</h6>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col lg="4" md="6" sm="12"><h6 style={{ marginTop: "9px" }}>has the capacity to earn:</h6></Col>

                                <Col lg="3" md="6" sm="12">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="number" id="income-b-number" defaultValue={props.income.income_b_number} />
                                    </InputGroup>
                                </Col>

                                <Col lg="2" md="6" sm="12">
                                    <h6 style={{ marginTop: "9px", marginLeft: "35px" }}>per</h6>
                                </Col>

                                <Col lg="3" md="6" sm="12">
                                    <Input type="text" id="income-b-text" defaultValue={props.income.income_b_text} />
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col lg="12">
                                    <h6 style={{ marginTop: "9px" }}>and has based the support order upon this imputed income.</h6>
                                </Col>
                            </Row>
                        </FormGroup>
                    </div>
                </div>;
            case 2:
                return <div>
                    <div>
                        <Row>
                            <Col>
                                <h6 style={{ fontSize: "20px", fontStyle: "italic" }}>a. Number of children who are the subjects of the support order (specify):</h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input type="text" id="children-a-text" defaultValue={props.children.children_a_text} />
                            </Col>
                        </Row>

                        <FormGroup>
                            <Row style={{ marginTop: "9px" }}>
                                <Col lg="6" md="12" sm="12">
                                    <h6 style={{ marginTop: "9px", fontSize: "20px", fontStyle: "italic" }}>b. Approximate percentage of time spent with:</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <h6 style={{ marginTop: "15px" }}>Petitioner/plaintiff:</h6>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <Input type="number" id="children-b-plaintiff" style={{ marginTop: "10px" }} defaultValue={props.children.children_b_plaintiff} />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row style={{ marginTop: "9px" }}>
                                <Col lg="3">
                                    <h6 style={{ marginTop: "9px", textAlign: "center" }} >Respondent/defendant:</h6>
                                </Col>
                                <Col lg="3">
                                    <Input type="number" id="children-b-respondent" defaultValue={props.children.children_b_respondent} />
                                </Col>
                                <Col lg="3">
                                    <h6 style={{ marginTop: "9px", textAlign: "center" }}>Other parent/party:</h6>
                                </Col>
                                <Col lg="3">
                                    <Input type="number" id="children-b-other" defaultValue={props.children.children_b_other} />
                                </Col>
                            </Row>
                        </FormGroup>
                    </div>
                </div>;

            case 3:
                return <div>
                    <div>
                        <Row>
                            <Col>
                                <h6>Hardships for the following have been allowed in calculating child support:</h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="4">
                                <h6> </h6>
                            </Col>
                            <Col lg="2">
                                <h6 style={{ textAlign: "center" }}>Petitioner/ plaintiff</h6>
                            </Col>
                            <Col lg="2">
                                <h6 style={{ textAlign: "center" }}>Respondent/ defendant</h6>
                            </Col>
                            <Col lg="2">
                                <h6 style={{ textAlign: "center" }}>Other parent/ party</h6>
                            </Col>
                            <Col lg="2">
                                <h6 style={{ textAlign: "center" }}>Ending time for hardship</h6>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="1">
                                <Input style={{ marginTop: "5px", height: "20px", width: "20px", marginLeft: "5px" }} type="checkbox" id="hardshipOtherCheck" value="1"
                                    onChange={(e) => {
                                        boxesHardship(e.target.value)
                                        enableDisable(e.target.id, "petitioner1", "respondent1", "otherParent1",
                                            "endingTime1")
                                    }}
                                    defaultChecked={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '1'))}
                                />
                            </Col>
                            <Col lg="3">
                                <h6 style={{ marginTop: "7px" }}>Other minor children:</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="petitioner1" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).petitioner_plaintiff : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="respondent1" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).respondent_defendent : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="otherParent1" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).other_parent : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <Input type="text" id="endingTime1" disabled
                                    defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '1')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '1')).end_time_hardship : ''} />
                            </Col>
                        </Row>

                        <Row style={{ marginTop: "9px" }} >
                            <Col lg="1">
                                <Input style={{ marginTop: "5px", height: "20px", width: "20px", marginLeft: "5px" }} type="checkbox" id="hardshipExtraCheck" value="2"
                                    onChange={(e) => {
                                        boxesHardship(e.target.value)
                                        enableDisable(e.target.id, "petitioner2", "respondent2", "otherParent2",
                                            "endingTime2")
                                    }}
                                    defaultChecked={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0}
                                />
                            </Col>
                            <Col lg="3">
                                <h6 style={{ marginTop: "5px" }}>Extraordinary medical expenses:</h6>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="petitioner2" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).petitioner_plaintiff : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="respondent2" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).respondent_defendent : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="otherParent2" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).other_parent : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <Input type="text" id="endingTime2" disabled
                                    defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '2')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '2')).end_time_hardship : ''} />
                            </Col>
                        </Row>

                        <Row style={{ marginTop: "6px" }}>
                            <Col lg="1">
                                <Input style={{ marginTop: "5px", height: "20px", width: "20px", marginLeft: "5px" }} type="checkbox" id="hardshipCatasCheck" value="3"
                                    onChange={(e) => {
                                        boxesHardship(e.target.value)
                                        enableDisable(e.target.id, "petitioner3", "respondent3", "otherParent3",
                                            "endingTime3")
                                    }}
                                    defaultChecked={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0}
                                />
                            </Col>
                            <Col lg="3">
                                <h6 style={{ marginTop: "7px" }}>Catastrophic losses:</h6>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="petitioner3" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).petitioner_plaintiff : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="respondent3" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).respondent_defendent : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="number" id="otherParent3" disabled
                                        defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).other_parent : ''} />
                                </InputGroup>
                            </Col>
                            <Col lg="2">
                                <Input type="text" id="endingTime3" disabled
                                    defaultValue={!isEmpty(props.hardships) && size(props.hardships.find(x => x.fl_342_hardship_type_id === '3')) > 0 ? (props.hardships.find(x => x.fl_342_hardship_type_id === '3')).end_time_hardship : ''} />
                            </Col>
                        </Row>
                    </div>
                </div>;
            case 4:
                return <div>
                    <Row>
                        <Col>
                            <h6>Does the low income adjustment applies?</h6>
                            <Input type="select" id="lowincome"
                                onChange={(e) => setLowIncome(JSON.parse(e.target.value))}
                                defaultValue={props.low_income.lowincome}>
                                <option selected value="-1"> -- select an option -- </option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>

                            </Input>
                        </Col>
                    </Row>

                </div>

            case 5:
                return <div>
                    <div>
                        <Row>
                            <Col>
                                <h6 style={{ marginTop: "5px", fontSize: "20px", fontStyle: "italic" }}>a.Base child support</h6>
                            </Col>
                        </ Row>

                        <FormGroup>
                            <Row>
                                <Col lg="4" md="12" sm="12">
                                    <Input type="checkbox" id="childPetitionerCheck" value="1" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                        onChange={(e) => { getCheckedValue(e.target.value) }}
                                        defaultChecked={!isEmpty(props.child_support.childCheckbox) && size(props.child_support.childCheckbox.find(x => x == '1'))} />
                                    <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>Petitioner/plaintiff</h6>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <Input type="checkbox" id="childRespondentCheck" value="2" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                        onChange={(e) => { getCheckedValue(e.target.value) }}
                                        defaultChecked={!isEmpty(props.child_support.childCheckbox) && size(props.child_support.childCheckbox.find(x => x == '2'))} />
                                    <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>Respondent/defendant</h6>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <Input type="checkbox" id="childOtherCheck" value="3" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                        onChange={(e) => { getCheckedValue(e.target.value) }}
                                        defaultChecked={!isEmpty(props.child_support.childCheckbox) && size(props.child_support.childCheckbox.find(x => x == '3'))} />
                                    <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>Other parent/party</h6>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col lg="5"><h6>must pay child support beginning</h6></Col>

                                <Col lg="3">
                                    <Input type="date" id="base-child-support-date"
                                        defaultValue={moment(props.child_support.base_child_support_date).format('YYYY-MM-DD')} />
                                </Col>

                                <Col lg="4">
                                    <h6>and continuing until further</h6>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col lg="12">
                                    <h6> order of the court, or until the child marries, dies, is emancipated, reachesage 19, or reaches</h6>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col lg="12">
                                    <h6>age 18 and is not a full-time high school student, whichever occurs first, as follows:</h6>
                                </Col>
                            </Row>
                        </FormGroup>

                        {!isEmpty(inputFields) && inputFields.map((inputField, index) => (
                            <div key={index}>

                                <FormGroup>
                                    <Row style={{ marginTop: "6px", textAlign: "center" }}>
                                        <Col lg="3" md="6" sm="12"><h6>Child’s Full Name</h6></Col>
                                        <Col lg="3" md="6" sm="12"><h6>Date of Birth</h6></Col>
                                        <Col lg="3" md="6" sm="12"><h6>Monthly Amount</h6></Col>
                                        <Col lg="3" md="6" sm="12"><h6>Payable To (Name)</h6></Col>
                                    </Row>
                                </FormGroup>

                                <FormGroup>
                                    <Row>
                                        <Col lg="3" md="6" sm="12">
                                            <Input type="text" id="child_name"
                                                value={inputField.child_name}
                                                onChange={(e) => { handleChangeInput(index, e) }} />
                                        </Col>
                                        <Col lg="3" md="6" sm="12">
                                            <Input type="date" id="child_dob"
                                                value={moment(inputField.child_dob).format('YYYY-MM-DD')}
                                                onChange={(e) => { handleChangeInput(index, e) }} />
                                        </Col>
                                        <Col lg="3" md="6" sm="12">
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>$</InputGroupText>
                                                </InputGroupAddon>
                                                <Input type="number" id="monthly_amount"
                                                    value={inputField.monthly_amount}
                                                    onChange={(e) => { handleChangeInput(index, e) }} />
                                            </InputGroup>
                                        </Col>
                                        <Col lg="3" md="6" sm="12">
                                            <Input type="text" id="payable_name"
                                                value={inputField.payable_name}
                                                onChange={(e) => { handleChangeInput(index, e) }} />
                                        </Col>
                                    </Row>
                                </FormGroup>

                                <FormGroup>
                                    <Row>
                                        <Col lg="12">
                                            {size(inputFields) < 4 && <IconButton
                                                onClick={() => handleAddFields(index)}
                                                style={{
                                                    float: "right",
                                                    color: "black",
                                                    marginTop: "15px",
                                                }}
                                            >
                                                <AddIcon />
                                            </IconButton>}

                                            <IconButton
                                                onClick={() => { handleRemoveFields(index); deleteCall(index) }}
                                                style={{ float: "right", color: "black", marginTop: "15px" }}
                                            >
                                                <RemoveIcon />
                                            </IconButton>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                        ))}
                        <ColoredLine />

                        <FormGroup>
                            <Row style={{ marginTop: "7px" }}>
                                <Col lg="1" style={{ marginTop: "6px" }}>
                                    <h6>Payable</h6>
                                </Col>
                                <Col lg="4">
                                    <Input type="checkbox" id="payableFullCheck" value="1" style={{ height: "20px", width: "20px", marginLeft: "10px", marginTop: "6px" }}
                                        onChange={(e) => { getSecondCheckedValue(e.target.value) }}
                                        defaultChecked={!isEmpty(props.child_support.payableCheckbox) && size(props.child_support.payableCheckbox.find(x => x == '1'))} />
                                    <h6 style={{ marginLeft: "35px", marginTop: "6px" }} >on the 1st of the month</h6>
                                </Col>
                                <Col lg="7">
                                    <Input type="checkbox" id="payableHalfCheck" value="2" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "6px" }}
                                        onChange={(e) => { getSecondCheckedValue(e.target.value) }}
                                        defaultChecked={!isEmpty(props.child_support.payableCheckbox) && size(props.child_support.payableCheckbox.find(x => x == '2'))} />
                                    <h6 style={{ marginLeft: "35px", marginTop: "6px" }} >one-half on the 1st and one-half on the 15th of the month</h6>
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col lg="12">
                                    <Input type="text" placeholder="Other (specify):" id="base-child-support-other-text" style={{ marginLeft: "2px", marginTop: "6px" }}
                                        defaultValue={props.child_support.base_child_support_other_text} />
                                </Col>
                            </Row>
                        </FormGroup>

                    </div>

                </div>

            case 6:
                return <div>
                    <div>
                        <Row>
                            <Col>
                                <h6 style={{ marginTop: "20px", fontSize: "20px", fontStyle: "italic" }}>(1) Child-care costs related to employment or reasonably necessary job training</h6>
                            </Col>
                        </Row>


                        <Row style={{ marginTop: "10px" }}>

                            <Col lg="3">
                                <h6>Petitioner/plaintiff must pay:</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <Input type="text" id="childCarePay1"
                                        defaultValue={props.mandatory_child_support.ChildPetitionerTotal}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText >%</InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>

                            <Col lg="2" style={{ paddingTop: "5px" }}>
                                <h6>of total or</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="text" id="childCarePer1"
                                        defaultValue={props.mandatory_child_support.ChildPetitionerMonth}
                                    />
                                </InputGroup>
                            </Col>

                            <Col lg="3">
                                <h6>per month <span style={{ paddingLeft: "30px" }}></span> child-care costs.</h6>
                            </Col>
                        </Row>


                        <Row style={{ marginTop: "10px" }}>
                            <Col lg="3">
                                <h6>Respondent/defendant must pay:</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <Input type="text" id="childCarePay2"
                                        defaultValue={props.mandatory_child_support.ChildRespondentTotal}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText>%</InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>

                            </Col>

                            <Col lg="2" style={{ paddingTop: "5px" }}>
                                <h6>of total or</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="text" id="childCarePer2"
                                        defaultValue={props.mandatory_child_support.ChildRespondentMonth}
                                    />
                                </InputGroup>
                            </Col>

                            <Col lg="3">
                                <h6>per month <span style={{ paddingLeft: "30px" }}></span> child-care costs.</h6>
                            </Col>
                        </Row>


                        <Row style={{ marginTop: "10px" }}>
                            <Col lg="3">
                                <h6>Other parent/party must pay:</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <Input type="text" id="childCarePay3"
                                        defaultValue={props.mandatory_child_support.ChildOtherTotal}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText>%</InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>

                            <Col lg="2" style={{ paddingTop: "5px" }}>
                                <h6>of total or</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="text" id="childCarePer3"
                                        defaultValue={props.mandatory_child_support.ChildOtherMonth}
                                    />
                                </InputGroup>
                            </Col>

                            <Col lg="3">
                                <h6>per month <span style={{ paddingLeft: "30px" }}></span> child-care costs.</h6>
                            </Col>
                        </Row>



                        <Row style={{ marginTop: "10px" }}>
                            <Col>

                                <Input type="text" id="child-care-cost-text" placeholder="Costs to be paid as follows(specify):"
                                    defaultValue={props.mandatory_child_support.ChildCostSpecify}
                                />
                            </Col>
                        </Row>


                        <Row>
                            <Col>
                                <h6 style={{ marginTop: "20px", fontSize: "20px", fontStyle: "italic" }} >(2) Reasonable uninsured health-care costs for the children</h6>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Col lg="3">
                                <h6>Petitioner/plaintiff must pay:</h6>

                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <Input type="text" id="reasonablePay1"
                                        defaultValue={props.mandatory_child_support.ReasonPetitionerTotal}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText>%</InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>

                            <Col lg="2" style={{ paddingTop: "5px" }}>
                                <h6>of total or</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="text" id="reasonablePer1"
                                        defaultValue={props.mandatory_child_support.ReasonPetitionerMonth}
                                    />
                                </InputGroup>
                            </Col>

                            <Col lg="3" style={{ paddingTop: "5px" }}>
                                <h6>per month.</h6>
                            </Col>
                        </Row>


                        <Row style={{ marginTop: "10px" }}>

                            <Col lg="3">
                                <h6>Respondent/defendant must pay:</h6>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <Input type="text" id="reasonablePay2"
                                        defaultValue={props.mandatory_child_support.ReasonRespondentTotal}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText>%</InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col lg="2" style={{ paddingTop: "5px" }}>
                                <h6>of total or</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="text" id="reasonablePer2"
                                        defaultValue={props.mandatory_child_support.ReasonRespondentMonth}
                                    />
                                </InputGroup>
                            </Col>
                            <Col lg="3" style={{ paddingTop: "5px" }}>
                                <h6>per month.</h6>
                            </Col>
                        </Row>


                        <Row style={{ marginTop: "10px" }}>
                            <Col lg="3">
                                <h6>Other parent/party must pay:</h6>
                            </Col>
                            <Col lg="2">
                                <InputGroup>
                                    <Input type="text" id="reasonablePay3"
                                        defaultValue={props.mandatory_child_support.ReasonOtherTotal}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText>%</InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col lg="2" style={{ paddingTop: "5px" }}>
                                <h6>of total or</h6>
                            </Col>

                            <Col lg="2">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="text" id="reasonablePer3"
                                        defaultValue={props.mandatory_child_support.ReasonOtherMonth}
                                    />
                                </InputGroup>
                            </Col>

                            <Col lg="3" style={{ paddingTop: "5px" }}>
                                <h6>per month.</h6>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: "10px" }}>
                            <Col>
                                <Input type="text" id="reasonable-cost-text" placeholder="Costs to be paid as follows(specify):"
                                    defaultValue={props.mandatory_child_support.ReasonCostSpecify}
                                />
                            </Col>
                        </Row>

                    </div>
                </div>



            case 7:
                return <div>
                    <Row style={{ fontSize: "20px" }}>
                        <h6>If you have any of these additional agreements, please include them. Otherwise, click next.</h6>
                    </Row>

                    <FormGroup>
                        <Row>
                            <Col>
                                <h6 style={{ marginTop: "20px", fontSize: "20px", fontStyle: "italic" }}>(1) Costs related to the educational or other special needs of the children</h6>
                            </Col>
                        </Row>


                        <div>
                            <Row style={{ marginTop: "10px" }}>
                                <Col lg="3">
                                    <h6>Petitioner/plaintiff must pay:</h6>
                                </Col>
                                <Col lg="2">
                                    <InputGroup>
                                        <Input type="text" id="additionalCostPay1"
                                            defaultValue={props.additional_child_support.CostPetitionerTotal}
                                        />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>%</InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                                <Col lg="2" style={{ paddingTop: "5px" }}>
                                    <h6>of total or</h6>
                                </Col>

                                <Col lg="2">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" id="additionalCostPer1"
                                            defaultValue={props.additional_child_support.CostPetitionerMonth}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" style={{ paddingTop: "5px" }}>
                                    <h6>per month.</h6>
                                </Col>
                            </Row>


                            <Row style={{ marginTop: "10px" }}>

                                <Col lg="3">
                                    <h6>Respondent/defendant must pay:</h6>
                                </Col>
                                <Col lg="2">
                                    <InputGroup>
                                        <Input type="text" id="additionalCostPay2"
                                            defaultValue={props.additional_child_support.CostRespondentTotal}
                                        />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>%</InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                                <Col lg="2" style={{ paddingTop: "5px" }}>
                                    <h6>of total or</h6>
                                </Col>

                                <Col lg="2">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" id="additionalCostPer2"
                                            defaultValue={props.additional_child_support.CostRespondentMonth}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" style={{ paddingTop: "5px" }}>
                                    <h6>per month.</h6>
                                </Col>
                            </Row>


                            <Row style={{ marginTop: "10px" }}>

                                <Col lg="3">
                                    <h6>Other parent/party must pay:</h6>
                                </Col>
                                <Col lg="2">
                                    <InputGroup>
                                        <Input type="text" id="additionalCostPay3"
                                            defaultValue={props.additional_child_support.CostOtherTotal}
                                        />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>%</InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                                <Col lg="2" style={{ paddingTop: "5px" }}>
                                    <h6>of total or</h6>
                                </Col>
                                <Col lg="2">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" id="additionalCostPer3"
                                            defaultValue={props.additional_child_support.CostOtherMonth}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" style={{ paddingTop: "5px" }}>
                                    <h6>per month.</h6>
                                </Col>
                            </Row>

                            <Row style={{ marginTop: "10px" }}>
                                <Col>
                                    <Input type="text" id="additional-child-support-cost-text" placeholder="Costs to be paid as follows(specify):"
                                        defaultValue={props.additional_child_support.CostCostSpecify}
                                        style={{ marginTop: "5px" }}
                                    />
                                </Col>
                            </Row>
                        </div>


                        <Row>
                            <Col>
                                <h6 style={{ marginTop: "20px", fontSize: "20px", fontStyle: "italic" }} >(2) Travel expenses for visitation</h6>
                            </Col>
                        </Row>


                        <div>
                            <Row style={{ marginTop: "10px" }}>

                                <Col lg="3">
                                    <h6>Petitioner/plaintiff must pay:</h6>
                                </Col>
                                <Col lg="2">
                                    <InputGroup>
                                        <Input type="text" id="additionalTravelPay1"
                                            defaultValue={props.additional_child_support.TravelPetitionerTotal}
                                        />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>%</InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>

                                <Col lg="2" style={{ paddingTop: "5px" }}>
                                    <h6>of total or</h6>
                                </Col>

                                <Col lg="2">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" id="additionalTravelPer1"
                                            defaultValue={props.additional_child_support.TravelPetitionerMonth}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" style={{ paddingTop: "5px" }}>
                                    <h6>per month.</h6>
                                </Col>
                            </Row>


                            <Row style={{ marginTop: "10px" }}>

                                <Col lg="3">
                                    <h6>Respondent/defendant must pay:</h6>
                                </Col>
                                <Col lg="2">
                                    <InputGroup>
                                        <Input type="text" id="additionalTravelPay2"
                                            defaultValue={props.additional_child_support.TravelRespondentTotal}
                                        />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>%</InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>

                                <Col lg="2" style={{ paddingTop: "5px" }}>
                                    <h6>of total or</h6>
                                </Col>

                                <Col lg="2">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" id="additionalTravelPer2"
                                            defaultValue={props.additional_child_support.TravelRespondentMonth}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" style={{ paddingTop: "5px" }}>
                                    <h6>per month.</h6>
                                </Col>
                            </Row>


                            <Row style={{ marginTop: "10px" }}>

                                <Col lg="3">
                                    <h6>Other parent/party must pay:</h6>
                                </Col>
                                <Col lg="2">
                                    <InputGroup>
                                        <Input type="text" id="additionalTravelPay3"
                                            defaultValue={props.additional_child_support.TravelOtherTotal}
                                        />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>%</InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>

                                <Col lg="2" style={{ paddingTop: "5px" }}>
                                    <h6>of total or</h6>
                                </Col>

                                <Col lg="2">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" id="additionalTravelPer3"
                                            defaultValue={props.additional_child_support.TravelOtherMonth}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col lg="3" style={{ paddingTop: "5px" }}>
                                    <h6>per month.</h6>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: "10px" }}>
                                <Col>
                                    <Input type="text" id="additional-child-support-travel-cost-text" placeholder="Costs to be paid as follows(specify):"
                                        defaultValue={props.additional_child_support.TravelCostSpecify}
                                        style={{ marginTop: "5px" }}
                                    />
                                </Col>
                            </Row>
                        </div>

                    </FormGroup>
                </div>

            case 8:
                return <div>
                    <Row>
                        <Col>
                            <h6>Is this child support amount non-guideline child support?</h6>
                            <Input type="select" id="guidelineSupport"
                                defaultValue={props.guidelineSupport}
                                onChange={(e) => setGuideline(JSON.parse(e.target.value))}>
                                <option selected value="-1"> -- select an option -- </option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </Input>
                        </Col>

                    </Row>
                    {guideline == "1" && <Alert style={{ marginTop: "10px" }} variant="filled" severity="warning">
                        Warning: Make sure to complete the Non Guideline Child Support Interview
                    </Alert>}

                </div>

            case 9:
                return <div>
                    <Row>
                        <Col>
                            <h6>Please answer the following questions about your child(ren)'s health insurance coverage.</h6>
                        </Col>
                    </Row>
                    <FormGroup>

                        <Row>
                            <Col lg="1">
                                <h6>a. </h6> </Col>
                            <Col lg="11">
                                <h6>Health insurance coverage
                                    for the minor children of the parties must be maintained by the </h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="4">
                                <Input type="checkbox" id="health-care-expenses-pp" value="1" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesHealthInsurance(e.target.value)}
                                    defaultChecked={size(props.health_care_expenses.health_care_expenses_available.find(x => x === '1'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>petitioner/plaintiff</h6>
                            </Col>
                            <Col lg="4">
                                <Input type="checkbox" id="health-care-expenses-rd" value="2" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesHealthInsurance(e.target.value)}
                                    defaultChecked={size(props.health_care_expenses.health_care_expenses_available.find(x => x === '2'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>respondent/defendant</h6>
                            </Col>
                            <Col lg="4">
                                <Input type="checkbox" id="health-care-expenses-o" value="3" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesHealthInsurance(e.target.value)}
                                    defaultChecked={size(props.health_care_expenses.health_care_expenses_available.find(x => x === '3'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>other parent/party</h6>
                            </Col>
                        </Row>
                        <Row>
                            <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>if available at no or reasonable cost through their respective places of employment
                                or self-employment. Both parties are ordered to cooperate in the presentation, collection, and reimbursement of any health-care claims.
                                The parent ordered to provide health insurance must seek continuation of  coverage for the child after the child attains the age when
                                the child is no longer considered eligible for coverage as a dependent under the insurance contract, if the child is incapable of
                                self-sustaining employment because of a physically or mentally  disabling injury, illness, or condition and is chiefly dependent upon
                                the parent providing health insurance for support and  maintenance.</h6>
                        </Row>

                        <Row style={{ marginTop: "15px" }}>
                            <Col lg="1">
                                <h6>b. </h6>
                            </Col>
                            <Col lg="11">
                                <h6>Health insurance is not available to the</h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="4">
                                <Input type="checkbox" id="health-care-expenses-b-pp" value="1" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesHealthInsuranceNotAvail(e.target.value)}
                                    defaultChecked={size(props.health_care_expenses.health_care_expenses_not.find(x => x === '1'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>petitioner/plaintiff</h6>
                            </Col>
                            <Col lg="4">
                                <Input type="checkbox" id="health-care-expenses-b-rd" value="2" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesHealthInsuranceNotAvail(e.target.value)}
                                    defaultChecked={size(props.health_care_expenses.health_care_expenses_not.find(x => x === '2'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>respondent/defendant</h6>
                            </Col>
                            <Col lg="4">
                                <Input type="checkbox" id="health-care-expenses-b-o" value="3" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesHealthInsuranceNotAvail(e.target.value)}
                                    defaultChecked={size(props.health_care_expenses.health_care_expenses_not.find(x => x === '3'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>other parent/party</h6>
                            </Col>
                        </Row>
                        <Row>
                            <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>at a reasonable cost at this time.</h6>
                        </Row>

                        <Row style={{ marginTop: "15px" }}>
                            <Col lg="1">
                                <h6>c. </h6>
                            </Col>
                            <Col lg="1">
                                <Input type="checkbox" id="health-care-expenses-c" style={{ height: "20px", width: "20px", marginTop: "2px" }}
                                    defaultValue={(props.health_care_expenses.health_care_expenses_c)} />
                            </Col>
                            <Col lg="10">
                                <h6>The party providing coverage must assign the right of reimbursement to the other party. </h6>
                            </Col>
                        </Row>

                    </FormGroup>

                </div>

            case 10:
                return <div>
                    <div>
                        <Row>
                            <Col lg="4">
                                <Input type="checkbox" id="employment-search-order-pp" value="1" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesEploymentSearch(e.target.value)}
                                    defaultChecked={size(props.employment_search_order.employment_search_order_checkboxes.find(x => x === '1'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>petitioner/plaintiff</h6>
                            </Col>
                            <Col lg="4">
                                <Input type="checkbox" id="employment-search-order-rd" value="2" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesEploymentSearch(e.target.value)}
                                    defaultChecked={size(props.employment_search_order.employment_search_order_checkboxes.find(x => x === '2'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>respondent/defendant</h6>
                            </Col>
                            <Col lg="4">
                                <Input type="checkbox" id="employment-search-order-o" value="3" style={{ height: "20px", width: "20px", marginLeft: "2px", marginTop: "2px" }}
                                    onChange={(e) => boxesEploymentSearch(e.target.value)}
                                    defaultChecked={size(props.employment_search_order.employment_search_order_checkboxes.find(x => x === '3'))} />
                                <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>other parent/party</h6>
                            </Col>
                        </Row>
                        <Row>
                            <h6 style={{ marginLeft: "30px", marginTop: "2px" }}>is ordered to seek employment with the following terms and conditions: </h6>
                        </Row>
                        <Row>
                            <Input type="text" id="employment-search-order-text"
                                defaultValue={props.employment_search_order.employment_search_order_text} />
                        </Row>
                    </div>
                </div>

            case 11:
                return <div>
                    <Row>
                        <Col>
                            <Input type="textarea" placeholder="Specify:" id="other-orders-text"
                                defaultValue={props.other_orders_text} />
                        </Col>
                    </Row>
                </div>


            default:
                return 'Unknown step';
        }
    }




    const handleNext = () => {
        handlePostFunction();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        activeStep === 6 && setInputField(isEmpty(props.child_support.childDetail) ? [{ child_name: "", child_dob: "", monthly_amount: "", payable_name: "" }] : props.child_support.childDetail);
        setActiveStep((prevActiveStep) =>
            (props.printout === "1" && prevActiveStep === 4) ? prevActiveStep - 4 :
                prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <div className={classes.root}>
            {props.isFetchingGetChildSupport ?
                <div style={{ marginLeft: "42%", marginTop: "18%" }}>
                    <Loader
                        type="Puff"
                        color="#00BFFF"
                        height={120}
                        width={120}
                    />
                </div>
                :
                <div>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((label, index) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                                <StepContent>
                                    <Typography>{getStepContent(index)}</Typography>
                                    <div className={classes.actionsContainer}>
                                        <div>
                                            <Button
                                                disabled={activeStep === 0}
                                                onClick={handleBack}
                                                className={classes.button}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleNext}
                                                className={classes.button}
                                            >
                                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                            </Button>
                                        </div>
                                    </div>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === steps.length && (
                        <Paper square elevation={0} className={classes.resetContainer}>
                            <Typography>All steps completed - you&apos;re finished</Typography>
                            <div>
                                <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                                    Reset
                                </Button>
                                <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                                    Back
                                </Button>
                            </div>
                        </Paper>
                    )}
                    <div style={{ display: "flex", float: "right" }}>
                        <Button
                            style={{ marginRight: "1%" }}
                            variant="contained"
                            color="primary"
                            onClick={printFL192}
                        >
                            Print Form 192
                        </Button>

                        <Button
                            style={{ marginLeft: "1%" }}
                            variant="contained"
                            color="primary"
                            onClick={myFunction}
                        >
                            Print Form 342
                        </Button>
                    </div>

                </div>}
        </div>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        postData: (data) => dispatch(postData(data)),
        putCourtUsed: (data) => dispatch(putCourtUsed(data)),
        putIncome: (data) => dispatch(putIncome(data)),
        putChildren: (data) => dispatch(putChildren(data)),
        putHardships: (data) => dispatch(putHardships(data)),
        putLowIncome: (data) => dispatch(putLowIncome(data)),
        putChildSupport: (data) => dispatch(putChildSupport(data)),
        putMandatoryChildSupport: (data) => dispatch(putMandatoryChildSupport(data)),
        putAdditionalChildSupport: (data) => dispatch(putAdditionalChildSupport(data)),
        putNonGuidelineOrder: (data) => dispatch(putNonGuidelineOrder(data)),
        putHealthCareExpenses: (data) => dispatch(putHealthCareExpenses(data)),
        putEmploymentSearchOrder: (data) => dispatch(putEmploymentSearchOrder(data)),
        putOtherOrders: (data) => dispatch(putOtherOrders(data)),
        deleteChildCall: (data) => dispatch(deleteChildCall(data)),
        getChildSupport: (data) => dispatch(getChildSupport(data)),
    }
}

const mapStateToProps = (state, ownProps) => ({
    states: state.ProfileInformationReducer.states,
    petitioner: state.ProfileInformationReducer.petitionerDetails,
    respondent: state.ProfileInformationReducer.respondentDetails,
    court: state.ProfileInformationReducer.court,
    printout: state.childSupportInformationReducer.printout,
    income: state.childSupportInformationReducer.income,
    children: state.childSupportInformationReducer.children,
    hardships: state.childSupportInformationReducer.hardships,
    low_income: state.childSupportInformationReducer.low_income,
    child_support: state.childSupportInformationReducer.child_support,
    mandatory_child_support: state.childSupportInformationReducer.mandatory_child_support,
    additional_child_support: state.childSupportInformationReducer.additional_child_support,
    guidelineSupport: state.childSupportInformationReducer.guidelineSupport,
    health_care_expenses: state.childSupportInformationReducer.health_care_expenses,
    employment_search_order: state.childSupportInformationReducer.employment_search_order,
    other_orders_text: state.childSupportInformationReducer.other_orders_text,
    isFetchingGetChildSupport: state.childSupportInformationReducer.isFetchingGetChildSupport,

});

export default connect(mapStateToProps, mapDispatchToProps)(ChildSupportInformation);